import React from "react";
import { Star } from "lucide-react";
import intelycareLogo from "../../../assets/EMP_whyus/LovedByBusiness/intely-care-logo.webp";

function LovedByBusinesses() {
  return (
    <section
      className="
        bg-[white]

        py-20
        lg:py-28

        px-6
        sm:px-10
        lg:px-20
      "
    >
      {/* TOP BADGES */}
      <div
        className="
          flex
          flex-wrap
          justify-center
          items-center

          gap-4
          sm:gap-6

          text-[14px]
          sm:text-[16px]
          lg:text-[16px]
          lg:-mt-[30px]

          text-[#111111]
        "
      >
        <span>EWA Leader</span>
        <span className="hidden sm:block">|</span>

        <span>A+ BBB Accredited Business</span>
        <span className="hidden sm:block">|</span>

        <span>5-Star App Rating</span>
      </div>

      {/* MAIN HEADING */}
      <h2
        className="
          mt-10
          lg:mt-6

          text-center

          text-[#290001]
          text-[42px]
          sm:text-[60px]
          lg:text-[50px]
          lg:font-light

          leading-[0.95]
          lg:leading-[1.1]

          max-w-[1100px]

          mx-auto
        "
      >
        DailyPay is loved by businesses
        <br />
        and employees everywhere
      </h2>

      {/* FIRST ROW */}
      <div
        className="
          mt-24

          grid
          grid-cols-1
          lg:grid-cols-2

          gap-16
          lg:gap-24

          items-center
        "
      >
        {/* LEFT CONTENT */}
        <div>
          <h3
            className="
              text-[#290001]
              lg:mt-4

              text-[42px]
              lg:text-[40px]
              lg:tracking-tighter
              lg:font-[1100]

              font-sans

              leading-[1]
              lg:leading-[1.3]
            "
          >
            Our Clients Leverage DailyPay to 
            Reach Business Goals
          </h3>

          <p
            className="
              mt-10
              lg:mt-6

              text-[#111111]

              text-[22px]
              md:text-[22px]
              lg:text-[16px]
              lg:font-[500]

              leading-[1.5]

              max-w-[620px]
            "
          >
            Your peers are already seeing results with
            improved retention,<br /> engagement, and
            streamlined operations.
          </p>

          <button
            className="
              mt-10
              lg:mt-6

              text-[24px]
              md:text-[22px]
              md:font-[600]
              lg:text-[16px]
              lg:font-[700]

              text-[#111111]
            "
          >
            Explore client success stories →
          </button>
        </div>

       {/* RIGHT TESTIMONIAL CARD */}
<div
  className="
    bg-[#f4e6dc]

    rounded-[14px]

    p-6
    sm:p-8
    lg:p-10

    relative

    max-w-[720px]

   
    lg:h-[320px]
  "
>
  {/* QUOTE ICON */}
  <div
    className="
      absolute

      -top-[35px]
      left-[40px]

      text-[#ff5a00]

      text-[120px]

      leading-none

      z-10
    "
  >
    “
  </div>

  <p
    className="
          mt-8
          lg:mt-4

      text-[#290001]

      text-[22px]
      sm:text-[26px]
      lg:text-[18px]

      font-[700]

      leading-[1.3]
    "
  >
    In terms of measuring the success of
    DailyPay or other benefits, really what
    we look at is take rate. The take rate
    for DailyPay is magnitudes above any
    other benefit that we offer.
  </p>

  <div className="mt-10">
    <h4
      className="
        text-[22px]

        font-bold

        text-[#111111]
      "
    >
      John Shagoury
    </h4>

    <p
      className="
        mt-1

        text-[18px]

        text-[#111111]
      "
    >
      President & COO | Intelycare
    </p>
  </div>

 <img
  src={intelycareLogo}
  alt="IntelyCare"

  className="
    mt-8

    w-[180px]
    sm:w-[220px]
    lg:w-[160px]

    h-auto

    object-contain
  "
/>
</div>
      </div>

      {/* SECOND ROW */}
      <div
        className="
          mt-28

          grid
          grid-cols-1
          lg:grid-cols-2

          gap-16
          lg:gap-24

          items-center
        "
      >
        {/* LEFT REVIEW CARD */}
        <div
  className="
    bg-[#f4e6dc]

    rounded-[14px]

    p-5
    sm:p-6
    lg:p-7

    relative

    w-full
    max-w-[720px]

    min-h-[320px]
    lg:h-[100px]
  "
>
  {/* QUOTE ICON */}
  <div
    className="
      absolute

      -top-[35px]
      left-[40px]

      text-[#ff5a00]

      text-[120px]

      leading-none

      z-10
    "
  >
    “
  </div>

  <p
    className="
      mt-8

      text-[#290001]

      text-[22px]
      sm:text-[26px]
      lg:text-[18px]

      font-[700]

      leading-[1.3]
    "
  >
    I'm a mom of 4 young kids and
    [DailyPay] has been a savior in so
    many situations for us when things
    pop up and emergencies happen.
  </p>

  <div className="mt-8">
    <h4
      className="
        text-[22px]
        md:text-[24px]
        lg:text-[18px]

        font-bold

        text-[#111111]
      "
    >
      Nicole S.
    </h4>

    <p
      className="
        mt-1

        text-[18px]

        text-[#111111]
      "
    >
      NPS review
    </p>
  </div>

  {/* RATINGS */}
  <div
    className="
      mt-1
      lg:-mt-[30px]
      lg:text-[16px]
      justify-end

      flex
      flex-wrap

      gap-8
    "
  >
    {/* APPLE */}
    <div>
      <div
        className="
          flex
          items-center

          gap-2
        "
      >
        <span
          className="
            text-[40px]
            md:text-[40px]
            lg:text-[36px]

            text-[#4b4b4b]
          "
        >
          4.8
        </span>

        <Star
          fill="#4b4b4b"
          className="w-7 h-7 text-[#4b4b4b]"
        />
      </div>

      <p
        className="
          mt-2

          text-[16px]
          lg:text-[14px]

          text-[#555]
        "
      >
        439k Ratings
        <br />
        Apple App store
      </p>
    </div>

    {/* DIVIDER */}
    <div
      className="
        hidden
        sm:block

        w-[1px]

        bg-[#c7b7ab]
      "
    />

    {/* GOOGLE */}
    <div>
      <div
        className="
          flex
          items-center

          gap-2
        "
      >
        <span
          className="
            text-[40px]
            md:text-[40px]
            lg:text-[36px]

            text-[#4b4b4b]
          "
        >
          4.6
        </span>

        <Star
          fill="#4b4b4b"
          className="w-7 h-7 text-[#4b4b4b]"
        />
      </div>

      <p
        className="
          mt-2

          text-[16px]
          lg:text-[14px]

          text-[#555]
        "
      >
        221k Ratings
        <br />
        Google Play store
      </p>
    </div>
  </div>
</div>

        {/* RIGHT CONTENT */}
        <div>
          <h3
            className="
              text-[#290001]

              text-[42px]
              tracking-[0.5px]
              lg:text-[40px]
              lg:tracking-tighter
              lg:font-[1100]

              font-sans

              leading-[1]
            "
          >
            5-Star Rating From Over
            430,000 DailyPay App Users
          </h3>

          <p
            className="
              mt-8
              lg:mt-6

              text-[#111111]

              text-[22px]
              md:text-[22px]
              lg:text-[16px]
              lg:font-[500]

              leading-[1.5]
              lg:leading-[1.4]

              max-w-[620px]
            "
          >
            When employees love a benefit this much,
            you know it's driving real <br /> results for
            your business.
          </p>

          <button
            className="
              mt-10
              lg:mt-6

              text-[24px]
              md:text-[22px]
              md:font-[600]
              lg:text-[16px]
              lg:font-[700]

              text-[#111111]
            "
          >
            Read employee reviews →
          </button>
        </div>
      </div>
    </section>
  );
}

export default LovedByBusinesses;